export const projectIsTypeKanban = state => {
  const {origProject} = state.configuration.project.editor.general.fieldset;
  if(!origProject) {
    return null;
  }
  return origProject.projectType === ttb.constants.projectTypes.kanban;
};


// WEBPACK FOOTER //
// ../redux/store/configuration/project/selectors.js